export default __webpack_public_path__ + "static/assets/4a7eba64b7666cd4c3801bf85f5def06.png";